import React from 'react'
import * as StyledComponent from '../styles'

const ProductStateLabel = (props, context) => {
  return <StyledComponent.ProductStateLabel className={`${props.label_class} product-state-label`}>
    { props.label }
  </StyledComponent.ProductStateLabel>
}

ProductStateLabel.defaultProps = {
  label: '',
  label_class: ''
}

export default ProductStateLabel



// WEBPACK FOOTER //
// ./src/components/ProductStateLabel.js